export const ORDER_DETAIL_PAGE_LOADED = {
  name: "order_detail_page_loaded",
  attributes: {
    category: "category",
    subCategory: "subcategory",
    categoryId: "category_id",
    orderId: "order_id",
    orderStatus: "order_status",
    paymentStatus: "payment_status",
  },
};

export const ORDER_CONFIRMATION_PAGE_LOADED = {
  name: "order_confirmation_page_loaded",
  attributes: {
    category: "category",
    subCategory: "subcategory",
    categoryId: "category_id",
    orderId: "order_id",
    orderStatus: "order_status",
    paymentStatus: "payment_status",
    promoSource: "promo_source",
    productType: "product_type",
    totalPrice: "total_price",
    cartItems: "cart_items",
  },
};

export const FUEL_ORDER_DETAIL_PAGE_LOADED = {
  name: "buy_fuel_order_detail_page_loaded",
  attributes: {
    category: "category",
    subCategory: "subcategory",
    categoryId: "category_id",
    orderId: "order_id",
    orderStatus: "order_status",
    paymentStatus: "payment_status",
  },
};

export const PAY_NOW_CLICKED = {
  name: "pay_now_clicked",
  attributes: {
    categoryId: "category_id",
    paymentMethod: "payment_method",
    amount: "amount",
  },
};

export const APPLY_PROMO_CLICKED = {
  name: "apply_promo_clicked",
  attributes: {
    categoryId: "category_id",
    originSource: "origin_source",
  },
};

export const CHANGE_PAYMENT_METHOD = {
  name: "change_payment_method",
  attributes: {
    categoryId: "category_id",
    paymentMethod: "payment_method",
  },
};

export const BOTTOM_OFFER_CARD_CLICKED = {
  name: "card_clicked",
  attributes: {
    categoryId: "category_id",
    pageName: "page_name",
    screenId: "screen_id",
    redirectionUrl: "redirection_url",
    position: "position",
    section: "section",
  },
};

export const BOTTOM_OFFER_CARD_VIEWED = {
  name: "card_viewed",
  attributes: {
    categoryId: "category_id",
    pageName: "page_name",
    screenId: "screen_id",
    redirectionUrl: "redirection_url",
    position: "position",
    section: "section",
  },
};
